
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { AppointmentBooking } from './components/AppointmentBooking';
import { ClinicOverview } from './components/ClinicOverview';
import { AboutDoctor } from './components/AboutDoctor';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ServiceAreas } from './components/ServiceAreas';
import { Contact } from './components/Contact';
import { Navbar } from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <a
        href="#hero"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[9999] focus:bg-teal-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg"
      >
        Skip to main content
      </a>
      <Navbar />
      <main
        id="main-content"
        itemScope
        itemType="https://schema.org/Dentist"
      >
        <Hero />
        <ClinicOverview />
        <AboutDoctor />
        <Services />
        <AppointmentBooking />
        <Testimonials />
        <FAQ />
        <ServiceAreas />
        <Contact />
      </main>
    </div>
  );
}
